function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "duplicate_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "duplicate_svg__a",
  transform: "translate(47 133)",
  d: "M0 0h16v16H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "duplicate_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "duplicate_svg__c",
  d: "M1.3 16a.3.3 0 01-.3-.3V3.3a.3.3 0 01.3-.3H4v1H2v11h9v-2H4.3a.3.3 0 01-.3-.3V.301a.3.3 0 01.3-.3h7.15l.528.531a.283.283 0 01.029.025L14 2.573l1 1.007v9.126a.3.3 0 01-.3.3H12v2.7a.3.3 0 01-.3.3zM5 12h9V5h-3.4a.3.3 0 01-.3-.3V1H5zm8.986-8l-2.554-2.638a2.47 2.47 0 00-.132-.11v2.749z"
}));

function SvgDuplicate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}

export default SvgDuplicate;